import { useStores } from "../../../../../stores/useStores";
import LoginButtons from "./LoginButtons";
import classNames from "classnames";
import { useGridType } from "../../../../../hooks/useGridType";
import { GridTypes } from "../../../../../utils/SchoolBlocksUtilities";
import styles from "./styles/PrivateLogin.module.scss";
import { Text } from "@radix-ui/themes";

export default function PrivateLogin() {
  const { userStore } = useStores();
  const gridType = useGridType();

  const containerClassName = classNames({
    ["sb-content-width"]: true,
    [styles.container]: true,
    [styles.containerTerrace]: gridType === GridTypes.terraced,
  });

  return (
    <div className={containerClassName}>
      <div className="sb-error-block">
        <div className="sb-error-message">
          <Text asChild color="red">
            <h3 className={styles.warning}>
              {userStore.id
                ? "This is a private page that you do not have permission to view."
                : "This page is private, please log in if you have viewing permissions."}
            </h3>
          </Text>
          {!!userStore.id || (
            <div style={{ marginTop: "1rem" }}>
              <LoginButtons />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
